package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class AccountAuthCodeResponse(
    @SerialName("code") val authCode: String,
    @SerialName("redirectUri") val redirectUri: String,
    @SerialName("expiresIn") val expiresIn: Long,
    @SerialName("clientId") val clientId: String
)